const config = {
    APP_STORE : 'https://apps.apple.com/lk/app/examhub/id1567751663',
    GOOGLE_PLAY : 'https://play.google.com/store/apps/details?id=com.fonixss.examhublk&hl=en',
    FACEBOOK: "https://web.facebook.com/examhublk/?_rdc=1&_rdr",
    YOUTUBE: "https://www.youtube.com/watch?v=XXO-y5LWLn4",
    WHATAPP: "https://wa.link/b7hi6y"
  };
  
  export default config;